// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1":"6eaf4ae2","45":"d250023f","94":"d250023f","118":"d250023f","721":"cc25348c","724":"a99f0b95","815":"d250023f","844":"41fb8956"}[chunkId] + ".chunk.css";
};